module.exports = __webpack_public_path__ + "assets/img/banner-patentes-1920.jpg";